var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("h4", [_vm._v("Certificado digital")]),
    _vm._m(0),
    _c("div", { staticClass: "divider" }),
    _vm._m(1),
    _c("div", { staticClass: "row" }, [
      _vm._m(2),
      _c("div", { staticClass: "col-md-6 col-sm-12" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.configurations.textTemplate,
              expression: "configurations.textTemplate"
            }
          ],
          staticClass: "form-control",
          staticStyle: { "font-size": "14px" },
          attrs: {
            rows: "5",
            cols: "80",
            "ng-change": "renderizarPlantillaSoloTexto()"
          },
          domProps: { value: _vm.configurations.textTemplate },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.configurations, "textTemplate", $event.target.value)
            }
          }
        })
      ]),
      _c("div", { staticClass: "col-md-6 col-sm-12" }, [
        _c("div", { staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.configurations.templateType,
                expression: "configurations.templateType"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "radio", id: "only_text" },
            domProps: {
              value: _vm.configType.onlyText,
              checked: _vm._q(
                _vm.configurations.templateType,
                _vm.configType.onlyText
              )
            },
            on: {
              change: function($event) {
                return _vm.$set(
                  _vm.configurations,
                  "templateType",
                  _vm.configType.onlyText
                )
              }
            }
          }),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "only_text" } },
            [_vm._v(" Solo Texto ")]
          )
        ]),
        _c("div", { staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.configurations.templateType,
                expression: "configurations.templateType"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "radio", id: "draw" },
            domProps: {
              value: _vm.configType.draw,
              checked: _vm._q(
                _vm.configurations.templateType,
                _vm.configType.draw
              )
            },
            on: {
              change: function($event) {
                return _vm.$set(
                  _vm.configurations,
                  "templateType",
                  _vm.configType.draw
                )
              }
            }
          }),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "draw" } },
            [_vm._v(" Dibujar mi Firma ")]
          )
        ]),
        _c("div", { staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.configurations.templateType,
                expression: "configurations.templateType"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "radio", id: "atached" },
            domProps: {
              value: _vm.configType.atached,
              checked: _vm._q(
                _vm.configurations.templateType,
                _vm.configType.atached
              )
            },
            on: {
              change: function($event) {
                return _vm.$set(
                  _vm.configurations,
                  "templateType",
                  _vm.configType.atached
                )
              }
            }
          }),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "atached" } },
            [_vm._v(" Subir mi firma ")]
          )
        ]),
        _c("div", { staticClass: "form-check" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.configurations.templateType,
                expression: "configurations.templateType"
              }
            ],
            staticClass: "form-check-input",
            attrs: { type: "radio", id: "desing" },
            domProps: {
              value: _vm.configType.desing,
              checked: _vm._q(
                _vm.configurations.templateType,
                _vm.configType.desing
              )
            },
            on: {
              change: function($event) {
                return _vm.$set(
                  _vm.configurations,
                  "templateType",
                  _vm.configType.desing
                )
              }
            }
          }),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "desing" } },
            [_vm._v(" Diseñar mi firma ")]
          )
        ])
      ])
    ]),
    _c("br"),
    _vm.configurations.templateType === _vm.configType.onlyText
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3" },
            [
              _c("SignaturePreview", {
                attrs: {
                  configurations: _vm.configurations,
                  user: _vm.user,
                  company: _vm.company
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.configurations.templateType === _vm.configType.atached
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col col-lg-6 col-md-12 col-sm-12 col-12" },
            [_c("FileSignatureSelector", { on: { input: _vm.setDrawImage } })],
            1
          ),
          _c(
            "div",
            { staticClass: "col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3" },
            [
              _c("SignaturePreview", {
                attrs: {
                  configurations: _vm.configurations,
                  user: _vm.user,
                  company: _vm.company
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.configurations.templateType === _vm.configType.desing
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col col-lg-6 col-md-12 col-sm-12 col-12" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.configurations.emulation,
                    expression: "configurations.emulation"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.configurations.emulation },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.configurations,
                      "emulation",
                      $event.target.value
                    )
                  }
                }
              })
            ]
          ),
          _c(
            "div",
            { staticClass: "col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3" },
            [
              _c("SignaturePreview", {
                attrs: {
                  configurations: _vm.configurations,
                  user: _vm.user,
                  company: _vm.company
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.configurations.templateType === _vm.configType.draw
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col col-lg-6 col-md-12 col-sm-12 col-12" },
            [
              _c("SignaturePad", { on: { input: _vm.setDrawImage } }),
              _c("span", [
                _vm._v(
                  "Nota: Si no se actualiza la imagen, no se reflejara al guardar los cambios"
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col col-lg-6 col-md-12 col-sm-12 col-12 mt-sm-3" },
            [
              _c("SignaturePreview", {
                attrs: {
                  configurations: _vm.configurations,
                  user: _vm.user,
                  company: _vm.company
                }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-md-12" }, [
        _c("p", [
          _vm._v(
            " Cada vez que firmes digitalmente un documento, la estampa visual que se insertará en el documento, se verá tal como la configures aquí, para ello, tienes varias opciones, selecciona la que tu organización ha instruido o, si lo tienes permitido, seleccionar la que mas te acomode. "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-md-12" }, [
        _c("h4", [_vm._v("PLANTILLA")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("p", [
        _vm._v(
          " En el siguiente recuadro puedes escribir lo que se vera en tu firma, y mas abajo podras ver de forma instantanea el resultado final. Puedes usar algunas palabras clave que contienen información, podrian ser de utilidad a la hora de armar la plantilla de tu firma. Debes tener presente que el espacio disponible para escribir es limitado, solo pueden ser 5 lineas de texto. Cuidado con el largo de cada linea, ya que si no hay espacio suficiente, las palabras sobrantes pasarán a la siguiente linea. "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }